import { InquiryStatus } from '@models/inquiry';
import { InquiryStatusKr } from '@models/inquiry/extension';

import styles from './styles.module.scss';

interface Props {
    status: InquiryStatus;
}

function InquiryBadge({ status }:Props) {
  return (
        <span className={`${styles.badge} ${styles[`badge-${status.toLowerCase()}`]}`}>
            {InquiryStatusKr[status]}
        </span>
  );
}

export default InquiryBadge;
